var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"iconP",attrs:{"slot":"reference"},slot:"reference"},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.text != '-'),expression:"text != '-'"}],staticClass:"el-icon-document-copy pointer icon green-Cd0100",on:{"click":function($event){return _vm.copy(_vm.text)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }